// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Sv6ZU","label":"styles_label__UlVj7"};